import { render } from "./EmailTemplateForm.vue?vue&type=template&id=3db77ffb&scoped=true"
import script from "./EmailTemplateForm.vue?vue&type=script&lang=ts"
export * from "./EmailTemplateForm.vue?vue&type=script&lang=ts"

import "./EmailTemplateForm.vue?vue&type=style&index=0&id=3db77ffb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3db77ffb"

export default script